import { Options, useMixins } from '@/modules/booster/model/mixins';

export function useBoosterItemAdd() {
    const { v$, model, actions } = useMixins();

    return { v$, model, actions, Options };
}
